import styled from 'styled-components';
import tw from 'twin.macro';

export const MenuItemWrapperStyles = styled.div`
  ${tw`grid grid-cols-1 gap-3 overflow-y-scroll lg:grid-cols-2 max-h-96`}
`;

const MenuItemStyles = styled.div`
  ${tw`relative grid content-center grid-cols-2 text-sm bg-white lg:grid-cols-2 gap-x-5 gap-y-0`}
  /* grid-template-columns: 100px 1fr; */
  grid-template-rows: repeat(auto-fill, minmax(150px, 1fr));
  /* grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); */
  /* grid-template-rows: 1fr 1fr; */

  /* align-items: center; */

  /* background: var(--white); */
  h3 {
    ${tw`text-base`}
  }
  .menu-item__content {
    ${tw`relative`}
    button {
      ${tw`mt-3 font-bold underline`}
    }
    span {
      ${tw`pt-2 text-base font-bold text-red-600 underline`}
    }
  }

  p {
    margin: 0;
  }
  button {
    ${tw`w-full px-2 py-1 text-sm transition border border-red-600 rounded shadow-xl sm:w-auto hover:bg-red-400 hover:text-white`};
    /* font-size: 1.5rem; */
    &.remove {
      ${tw`absolute right-0 flex items-center justify-center w-6 h-6 p-4 m-0 text-xl leading-none text-red-600 no-underline shadow-none bottom-3 bg-none hover:text-white`};

      /* background: none;
    color: var(--red);
    font-size: 3rem;
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: none;
    line-height: 1rem; */
    }
  }
`;

export default MenuItemStyles;
